import { isEqual } from 'lodash-es'
import formatSearch from './formatSearch'

/**
 * @desc
 *  Add a search parameter.<br>
 *   Check if parameters are corrects.<br>
 *   Remove previous same search parameter.
 * @param {string}  searches  - List of search criteria
 * @param {string}  operator  - Operator of searching.
 * @param {string}  values    - Values of searching.
 * @param {string}  [operand]  - Operand of searching.
 * @return {common/model.PageableCollection} This.
 */
const addSearch = (searches, operator, values, operand) => {
  const formattedSearch = formatSearch(operator, values, operand)
  searches = searches.filter((search) => {
    return !isEqual(search, formattedSearch)
  })
  searches.push(formattedSearch)
  return searches
}

export default addSearch
